import { handleHttpResponse } from "../../utils/http_response_utils";

/**
 * Start a classification pipeline batch. Response includes `task_id`.
 *
 * `skipGeocoder` is batch-wide, not per company — geocoding is scoped by platform
 * and date range, so it's either run once for the batch or not at all.
 */
export const initClassificationPipeline = async (companies, skipGeocoder = false) => {
  const accessToken = localStorage.getItem("access-token");
  const response = await fetch("/api/init-classification-pipeline", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({ companies, skip_geocoder: skipGeocoder }),
  });
  return await handleHttpResponse(response);
};

/**
 * Cancel a running batch: flags it for the worker and stops its ECS tasks.
 * 404 if the run is unknown, 409 if it already finished.
 */
export const cancelPipelineRun = async (batchRunId) => {
  const accessToken = localStorage.getItem("access-token");
  const response = await fetch("/api/cancel-pipeline-run", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({ batch_run_id: batchRunId }),
  });
  return await handleHttpResponse(response);
};

/** List recent classification-pipeline batches (no report payloads). */
export const getPipelineRuns = async () => {
  const accessToken = localStorage.getItem("access-token");
  const response = await fetch("/api/get-pipeline-runs", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return await handleHttpResponse(response);
};

/** Per-company progress for one batch (`batch_run_id` = celery task_id). */
export const getPipelineRunStatus = async (batchRunId) => {
  const accessToken = localStorage.getItem("access-token");
  const response = await fetch(
    "/api/get-pipeline-run-status?" + new URLSearchParams({ batch_run_id: batchRunId }),
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );
  return await handleHttpResponse(response);
};
